import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import About from '../components/About';
import SEO from '../components/SEO';

const AboutPage = () => {
  return (
    <>
      <SEO 
        title="About CodeRidge | Enterprise IT, Security & Cloud Partner"
        description="Why organizations choose CodeRidge: intelligent automation, resilient cybersecurity, Cloud 3.0, and managed IT—as a strategic extension of leadership. Hyderabad, India."
        keywords="about CodeRidge, enterprise technology partner, managed services company Hyderabad, digital transformation partner"
        url="https://coderidge.in/about"
      />
      <Navbar />
      <div style={{ paddingTop: '80px' }}>
        <About />
      </div>
      <Footer />
    </>
  );
};

export default AboutPage;










